import { gql } from "@apollo/client"

export const APPROVE_REQUEST = gql`
  mutation ApproveRequest($obj: StockTakeApprovalRequestInput) {
    addUpdateStockTakeApproval(obj: $obj) {
      approvalRequest {
        id
        status
      }
    }
  }
`
